import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "native-back-button"

  connect() {
    super.connect()

    const element = this.bridgeElement
    const title = element.bridgeAttribute("title")

    this.send("connect", { title }, () => {
      this.element.click()
    })
  }

  disconnect() {
    super.disconnect()
    this.send("remove", {})
    if (this.element.parentNode) {
      this.element.parentNode.removeChild(this.element)
    }
  }
}
